import { useEffect } from 'react';

export default function ScriptInjector() {
  useEffect(() => {
    const injectScripts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-scripts`);
        const data = await response.json();
        
        // Inject head scripts
        if (data.head_scripts && data.head_scripts.trim()) {
          // Parse HTML and properly create elements
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.head_scripts, 'text/html');
          
          // Process each element in the head
          Array.from(doc.head.children).forEach(element => {
            if (element.tagName === 'SCRIPT') {
              // Create new script element (innerHTML doesn't execute)
              const script = document.createElement('script');
              
              // Copy all attributes
              Array.from(element.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              
              // Copy script content
              if (element.textContent) {
                script.textContent = element.textContent;
              }
              
              document.head.appendChild(script);
            } else if (element.tagName === 'META') {
              // Create meta tag
              const meta = document.createElement('meta');
              Array.from(element.attributes).forEach(attr => {
                meta.setAttribute(attr.name, attr.value);
              });
              document.head.appendChild(meta);
            } else {
              // For other elements (link, style, etc.)
              document.head.appendChild(element.cloneNode(true));
            }
          });
          
          // Process elements in body (might have comments or text)
          Array.from(doc.body.children).forEach(element => {
            if (element.tagName === 'SCRIPT') {
              const script = document.createElement('script');
              Array.from(element.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              if (element.textContent) {
                script.textContent = element.textContent;
              }
              document.head.appendChild(script);
            } else if (element.tagName === 'META') {
              const meta = document.createElement('meta');
              Array.from(element.attributes).forEach(attr => {
                meta.setAttribute(attr.name, attr.value);
              });
              document.head.appendChild(meta);
            } else {
              document.head.appendChild(element.cloneNode(true));
            }
          });
        }
        
        // Inject body scripts
        if (data.body_scripts && data.body_scripts.trim()) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.body_scripts, 'text/html');
          
          // Process scripts in body
          Array.from(doc.body.children).forEach(element => {
            if (element.tagName === 'SCRIPT') {
              const script = document.createElement('script');
              Array.from(element.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              if (element.textContent) {
                script.textContent = element.textContent;
              }
              document.body.appendChild(script);
            } else {
              document.body.appendChild(element.cloneNode(true));
            }
          });
        }
      } catch (error) {
        console.error('Error injecting scripts:', error);
      }
    };
    
    injectScripts();
  }, []);

  return null;
}
